/**
 * @generated SignedSource<<43bf9e00af5d47f9160f74f386c6427c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarChargesDisclaimer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getCheckoutChargesCurrencyDisclaimer_viewer">;
  readonly " $fragmentType": "CheckoutSidebarChargesDisclaimer_viewer";
};
export type CheckoutSidebarChargesDisclaimer_viewer$key = {
  readonly " $data"?: CheckoutSidebarChargesDisclaimer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarChargesDisclaimer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarChargesDisclaimer_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getCheckoutChargesCurrencyDisclaimer_viewer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chargeCurrencies",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "95eba2b9add4dfa1658afec4b796dbdf";

export default node;
